module.exports = __webpack_public_path__ + "static/media/4.790dfb11.jpg";